function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || "";
}

export function buildQuery(params) {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([k, val]) => {
    if (val === "" || val == null) return;
    if (Array.isArray(val)) {
      val.forEach((item) => {
        if (item !== "" && item != null) usp.append(`${k}[]`, String(item));
      });
    } else {
      usp.set(k, String(val));
    }
  });
  return usp.toString();
}

export function jsonHeaders() {
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-CSRF-Token": csrfToken(),
  };
}
